import React from 'react';
import { Panel } from 'react-bootstrap';
import Button from '../../UI/Button/Button';
import AutoSuggestion from '../../UI/AutoSuggestion/AutoSuggestion';

import Aux from '../../../hoc/Auxi/Auxi';
import './RescheduleCard.css';

const RescheduleCard = (props) => {
  
  return (
    <Panel className={ (props.rescheduleResponseMessage === null || props.rescheduleResponseMessage === "") ? "reschedule-card" : "reschedule-card " + props.rescheduleStatus }>
			<Panel.Body>
        {(props.rescheduleResponseMessage === null || props.rescheduleResponseMessage === "") ? 
          <Aux>
            <div className="reschedule-info">
              <div className="title">Reschedule candidate</div>
              {(Object.keys(props.selectedRescheduleJob).length > 0) ?
                <div className="selected-reschedulejob-container" onClick={props.handleRescheduleJobSelectClick}>
                  <div className="selected-reschedulejob-title">{props.selectedRescheduleJob.title}</div>
                  <div className="selected-reschedulejob-id">ID {props.selectedRescheduleJob.id}</div>
                </div>
              :
                <div className="reschedule-auto-suggestion">            
                  <AutoSuggestion 
                    value={props.autoSuggestionParam}
                    onChange={props.handleAutoSuggestion} 
                    placeholder="Enter Your Job Title or Job ID"
                    autoSuggestionResults={props.autoSuggestionResults}
                    handleClick={props.handleClick}
                  />            
                </div>
              }
            </div>
            
            <div className={(Object.keys(props.selectedRescheduleJob).length > 0) ? 'footer selected-reschedulejob' : 'footer'}>
              <Button 
                value={props.candidate_id} 
                onClick={props.handleCancelReschedule}
                className="cancel-button"
              >Cancel</Button>
              <Button 
                value={props.candidate_id} 
                onClick={props.handleCandidateReschedule}
                className="reschedule-button"
                disabled={(Object.keys(props.selectedRescheduleJob).length === 0) ? true : false}
              >Reschedule</Button>
            </div>
          </Aux>
        :
          <div className="reschedule-response-message">
            <div className={ "responce-icon " + props.rescheduleStatus }></div>
            {(props.rescheduleStatus === 'success') ?
              <Aux>
                <div className="candidate-name">{props.reschedulingCandidate.candidate_fname} {props.reschedulingCandidate.candidate_lname}</div>
                <div className="candidate-id">{props.reschedulingCandidate.candidate_source_id}</div>
                </Aux>
            : null }
            <div className={ "response-message " + props.rescheduleStatus }>{props.rescheduleResponseMessage}</div>
          </div>
        }
			</Panel.Body>
		</Panel>    
  );
}


export default RescheduleCard;


// WEBPACK FOOTER //
// ./src/components/Recruiter/RescheduleCard/RescheduleCard.js